export default {
  CONSTRUCT() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      fullscreen: document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
    };
  },
  RESIZE_WINDOW(state, data) {
    return state.set('width', data.width).set('height', data.height);
  },
  TOGGLE_FULLSCREEN(state) {
    const current = state.get('fullscreen');
    if (!current) {
      //document.documentElement.webkitRequestFullscreen();
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      }
      else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      }
      else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
      else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    }
    else {
    //  document.webkitExitFullscreen();
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
    return state.set('fullscreen', !current);
  }
};
